export default "__VITE_ASSET__CjKei6QH__"